// extracted by mini-css-extract-plugin
export default {"tab":"TabPanel_tab__161KA"};